import React, { useState } from 'react';

const Settings: React.FC = () => {
  

 

  return (
    <div className="space-y-6">
      {/* Header */}
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Settings</h1>
       
      </div>

     
    </div>
  );
};

export default Settings;
